module.exports = __webpack_public_path__ + "static/media/profile1.c96a9aeb.svg";